module.exports = __webpack_public_path__ + "static/media/collect-points.18728fcd.png";